angular.module('cimerFrontEndApp').directive('completeCurricula', ['$http', 'DocumentService', function ($http, DocumentService) {
    'use strict';
    return {
        restrict: 'E',
        templateUrl: '/Content/Templates/completeCurriculaTemplate.html',
        scope: {
            roleId: '@'
        },
        link: function (scope, element, attrs, ctrls) {
            scope.documents = [];
            DocumentService.getCompleteDocumentsByResearchRole(scope.roleId)
                .then(function (result) {
                    scope.documents = result.data;

                });
        }
    };
}]);